import { Pipe, PipeTransform } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { dateUtil } from "src/app/support/date-util";
import { toLower, trim } from "lodash-es";
import { translate } from "src/app/support/translate";

@Pipe({
  name: "formPropertyBind",
  standalone: false
})
export class ReportItemFormPropertyBindPipe implements PipeTransform {
  transform(
    property: string,
    dataSource: Record<string, any>,
    dataType: string
  ): string {
    return bindFormGridProperty(property, dataSource, dataType);
  }
}

export function bindFormGridProperty(
  property: string,
  dataSource: Record<string, any>,
  dataType: string
): string {
  const rawValue = dataSource[property];

  switch (dataType) {
    case "currency": {
      return `${rawValue} €`;
    }
    case "date": {
      return rawValue ? dateUtil(rawValue).format("DD/MM/YYYY") : "";
    }
    case "datetime": {
      return rawValue ? dateUtil(rawValue).format("DD/MM/YYYY HH:mm") : "";
    }
    case "boolean": {
      if (!rawValue) {
        return translate(marker("No"));
      }

      if (typeof rawValue === "boolean") {
        return rawValue ? translate(marker("Si")) : translate(marker("No"));
      }

      return trim(toLower(rawValue)) === "true"
        ? translate(marker("Si"))
        : translate(marker("No"));
    }
    case "translated": {
      return translate(rawValue);
    }
    case "text":
    case "number":
    default:
      return rawValue;
  }
}
